import React from 'react';
import HeaderNav from './common/HeaderNav';
import Footer from "./Footer";
import shipping from "../images/shipping.png"

function ShippingPolicy() {
    return (
        <>
            <HeaderNav />
            <div className='about-sec'>
                <div className='container-fluid p-0 about-container'>
                    <div className='row g-0 about-row'>
                        <div className='col-12'>
                            <img src={shipping} class="img-fluid" alt="img" />
                        </div>
                    </div>
                </div>
            </div>
            <div className='shipping-policy'>
                <div className='container'>
                    <div className='row'>
                        <h2 className='shipping-txt policy-header'>Shipping & Delivery Policy</h2>
                        <h5 className='text-muted my-4'>Last updated on Nov 27th 2022</h5>
                        <p className='my-4'>For International buyers, orders are shipped and delivered through registered international courier companies and/or International speed post only. For domestic buyers, orders are shipped through registered domestic courier companies and /or speed post only. Orders are shipped within 0-2 days or as per the delivery date agreed at the time of order confirmation and delivering of the shipment subject to Courier Company / post office norms. VIP NUMBER STUDIO is not liable for any delay in delivery by the courier company / postal authorities and only guarantees to hand over the consignment to the courier company or postal authorities within 0-2 days from the date of the order and payment or as per the delivery date agreed at the time of order confirmation. Delivery of all orders will be to the address provided by the buyer. Delivery of our services will be confirmed on your mail ID as specified during registration. For any issues in utilizing our services you may contact our helpdesk on or sales@vipnumberstudio.com</p>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}

export default ShippingPolicy
